import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const semesterRegisteredApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSemester: builder.query({
      query: ({ id }) => ({
        url: `semester-registered/${id}`,
      }),
      providesTags: ["SemesterRegistered"],
    }),
    getSemesters: builder.query({
      query: () => ({
        url: `semester-registered?query=all`,
      }),
      providesTags: ["SemesterRegisteredAll"],
    }),
    getSemestersPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `semester-registered?${query}`,
        };
      },
      providesTags: ["SemesterRegistereds"],
    }),

    addSemester: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `semester-registered`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toastHandler("Semester added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["SemesterRegistereds", "SemesterRegisteredAll"],
    }),

    deleteSemester: builder.mutation({
      query: ({ id }) => ({
        url: `semester-registered/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: "false",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Semester successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["SemesterRegistered", "SemesterRegistereds", "SemesterRegisteredAll"],
    }),

    updateSemester: builder.mutation({
      query: ({ id, values }) => ({
        url: `semester-registered/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toastHandler("Semester updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["SemesterRegistered", "SemesterRegistereds", "SemesterRegisteredAll"],
    }),
  }),
});

export const {
  useGetSemesterQuery,
  useGetSemestersQuery,
  useAddSemesterMutation,
  useDeleteSemesterMutation,
  useUpdateSemesterMutation,
  useGetSemestersPaginatedQuery,
} = semesterRegisteredApi;
